export const primary = "#1e56a0";
export const secondary = "#d6e4f0";
export const accent = "#163172";
export const background = "#d6e4f0";
